import React, { useCallback, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { Container, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { RootState } from 'slices';
import { Formik, FormikProps } from 'formik';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  setActiveInventoryIndex,
  setInventoryModalOpen,
  setShowAllValidateInventoryErrors,
} from 'slices/productInventory/reducer';
import InventoryForm from './InventoryForm';
import { validationSchema } from 'pages/Products/InventoryModal/ValidationSchema';
import { EditInventoryForm } from 'types/product/productInventoryTypes';
import { RESPONSE_MESSAGE } from './constants';
import { putUpdateInventory } from 'services/ProductInventoryService';

const InventoryModal = ({
  fetchAllProducts,
}: {
  fetchAllProducts: () => void;
}) => {
  const { t } = useTranslation();
  const dispatch: ThunkDispatch<RootState, void, Action> = useDispatch();

  const formikRef = useRef<FormikProps<EditInventoryForm>>(null);

  const productInventoryState = useSelector(
    (state: RootState) => state.ProductInventory
  );
  const { InventoryModal } = productInventoryState;

  const toggleModal = useCallback(
    (index: number | null = null) => {
      dispatch(setInventoryModalOpen(!InventoryModal.inventoryModalOpen));
      dispatch(setActiveInventoryIndex(index));
    },
    [InventoryModal.inventoryModalOpen, dispatch]
  );

  const closeModal = () => toggleModal(null);

  const submitInventoryForm = async (
    values: EditInventoryForm
    // resetForm: () => void
  ) => {
    if (!InventoryModal.activeInventoryIndex) return;

    try {
      const response = await putUpdateInventory(
        InventoryModal.activeInventoryIndex.toString(),
        values
      );

      if (response) {
        const { message, error_code } = response;

        if (message === 'OK' && error_code === 0) {
          closeModal();
          dispatch(setShowAllValidateInventoryErrors(false));
          toast.success(RESPONSE_MESSAGE.UPDATE_SUCCESS, {
            autoClose: 3000,
          });
          fetchAllProducts();
        } else {
          closeModal();
          dispatch(setShowAllValidateInventoryErrors(false));
          toast.error(message, { autoClose: 3000 });
        }
      } else {
        console.error('No response data returned');
        closeModal();
        dispatch(setShowAllValidateInventoryErrors(false));
        toast.error((response as any).message, { autoClose: 3000 });
      }
    } catch (error: any) {
      closeModal();
      dispatch(setShowAllValidateInventoryErrors(false));
      toast.error(error, { autoClose: 3000 });
    }
  };

  useEffect(() => {
    if (formikRef.current && formikRef.current.errors) {
      const errorKeys = Object.keys(formikRef.current.errors);
      if (errorKeys.length > 0) {
        const firstErrorField = document.querySelector(
          `[name="${errorKeys[0]}"]`
        ) as HTMLInputElement | null;

        if (
          firstErrorField !== null &&
          firstErrorField.type === 'hidden' &&
          firstErrorField.name === 'category'
        ) {
          const relatedElement = document.querySelector(
            '#react-select-2-input'
          ) as HTMLInputElement | null;

          if (relatedElement) {
            relatedElement.focus();
          }
        } else {
          if (firstErrorField) firstErrorField.focus();
        }
      }
    }
  }, [formikRef, InventoryModal.countSubmit]);

  return (
    <React.Fragment>
      <div className={`page-content`}>
        <Container fluid>
          <Modal
            size="lg"
            isOpen={InventoryModal.inventoryModalOpen}
            toggle={() => {
              closeModal();
              dispatch(setShowAllValidateInventoryErrors(false));
            }}
            backdrop={'static'}
            centered
          >
            <ModalHeader
              className="bg-light p-3"
              toggle={() => {
                closeModal();
                dispatch(setShowAllValidateInventoryErrors(false));
              }}
            >
              {t('Update Inventory')}
            </ModalHeader>
            <ModalBody>
              <Formik<EditInventoryForm>
                initialValues={InventoryModal.InventoryValues}
                validationSchema={validationSchema(t)}
                onSubmit={async (
                  values: EditInventoryForm
                  // { resetForm }: FormikHelpers<ProductFormDetailsInterface>
                ) => {
                  await submitInventoryForm(values);
                }}
                enableReinitialize={true}
                innerRef={formikRef}
              >
                {(formik) => (
                  <form
                    noValidate
                    className=""
                    // onSubmit={(e) => {
                    //   e.preventDefault();
                    //   formik.handleSubmit();
                    // }}
                    onSubmit={formik.handleSubmit}
                    // onSubmit={async (e) => {
                    //   e.preventDefault();
                    //   formik.handleSubmit();
                    //   console.log(formik.errors);
                    //   console.log(formik.values);
                    // }}
                  >
                    <InventoryForm formik={formik} dispatch={dispatch} />
                  </form>
                )}
              </Formik>
            </ModalBody>
          </Modal>
        </Container>
        <ToastContainer closeButton={false} limit={1} />
      </div>
    </React.Fragment>
  );
};
export default InventoryModal;
